import { TXTExtractor, PSSExtractor } from './dataExtractors/commaSepExtractor';
import { JSONExtractor } from './dataExtractors/jsonExtractor';
import { HTMLExtractor } from './dataExtractors/htmlExtractor';
import { XLSXExtractor } from './dataExtractors/xlsxExtractor';
import { XMLExtractor } from './dataExtractors/xmlExtractor';
import { PSSessionExtractor } from './dataExtractors/pssessionExtractor';
import { AoFExtractor } from './dataExtractors/aofExtractor';
import { ConcentrationExtractor } from './dataExtractors/concentrationExtractor';
import { CSVExtractor } from './dataExtractors/csvExtractor';
import { PictureExtractor } from './dataExtractors/pictureExtractor';
import { BaseParser } from './dataExtractors/baseExtractor';

const dataExtractors = {
  'aof': AoFExtractor,
  'cntr': ConcentrationExtractor,
  'csv': CSVExtractor,
  'hola': JSONExtractor,
  'html': HTMLExtractor,
  'png': PictureExtractor,
  'jpg': PictureExtractor,
  'jpeg': PictureExtractor,
  'gif': PictureExtractor,
  'bmp': PictureExtractor,
  'pss': PSSExtractor,
  'pssession': PSSessionExtractor,
  'txt': TXTExtractor,
  'trm': TXTExtractor,
  'xlsx': XLSXExtractor,
  'mtd': XMLExtractor,
}

function getExtension(fileName){
  if(!fileName)
    return null;
  const fileExtMatch = fileName.match(/\.([^.]+)$/);
  if (!fileExtMatch)
    return null;
  return fileExtMatch[1].toLowerCase();    
}

async function fromFile(parent, fileName, data, report) {
  const extFile = getExtension(fileName)
  if (extFile && dataExtractors[extFile]) {
    const extractor = new dataExtractors[extFile]();
    return await extractor.parse(parent, fileName, data, report);
  }
  return new BaseParser().getNewReturnValue();
}



export{
  fromFile,
  getExtension,
};
